import React, { Component } from "react";
import { Form, Checkbox } from "antd";
import { InputNumber } from "../../../../../components/common/input-number";
import { InputNumberDouble } from "../../../../../components/common/input-number-double";

const FEE_DATA = [
  {
    id: 1,
    title: " Phí qua đêm",
    feild: "CT006",
    suffix: "VNĐ/đêm",
  },
  {
    id: 2,
    title: " Phụ phí ngoài giờ",
    feild: "CT002",
    suffix: "VNĐ/giờ",
  },
  {
    id: 3,
    title: " Phụ phí vượt KM",
    feild: "CT003",
    suffix: "VNĐ/km",
  },
  {
    id: 4,
    title: " Phí tự lái ngày thường",
    feild1: "CT015",
    feild2: "OLQ002",
    parentFeild: "driving_weekday_fee",
    suffix: "VNĐ/ngày",
    limitKm: true,
  },
  {
    id: 5,
    title: " Phí tự lái ngày lễ",
    feild1: "CT016",
    suffix: "VNĐ/ngày",
    parentFeild: "driving_holiday_fee",
    feild2: "OLQ003",
    limitKm: true,
  },
  {
    id: 6,
    title: " Phí tự lái cuối tuần",
    feild1: "CT017",
    parentFeild: "driving_weekend_fee",
    suffix: "VNĐ/ngày",
    feild2: "OLQ004",
    limitKm: true,
  },
  {
    id: 7,
    title: " Phụ phí vượt Km tự lái",
    feild: "CT018",
    suffix: "VNĐ/km",
  },
];

export class EndHalfRates extends Component {
  state = {
    over_time_policies: [],
    time_use_policy_group_id: 0,
  };

  onChange = (e) => {
    const { checked } = e.target;
    this.setState({ time_use_policy_group_id: checked ? 1 : 0 });
  };

  render() {
    const { over_time_policies, time_use_policy_group_id } = this.state;
    const { limitEdit, isEdit, isOwner, typeOption } = this.props;
    return (
      <>
        <div
          style={{ marginBottom: time_use_policy_group_id === 1 ? 0 : 18 }}
          className="sub-title"
        >
          * Quy định về thời gian sử dụng{" "}
          <Checkbox
            disabled={!isEdit}
            onChange={this.onChange}
            checked={time_use_policy_group_id === 1}
          ></Checkbox>
        </div>
        {time_use_policy_group_id === 1 &&
          over_time_policies.map((value, index) => {
            return (
              <div
                style={{
                  marginBottom:
                    index === over_time_policies.length - 1 ? 18 : 0,
                }}
                className="policy"
                key={value.id}
              >
                + {value.name}
              </div>
            );
          })}
        {FEE_DATA.map((value) => {
          return (
            <Form.Item
              key={value.id}
              name={value.parentFeild ? value.parentFeild : value.feild}
              label={
                <div className="label-special">
                  <div className="plus">+</div>
                  <div>{` ${value.title}:`}</div>
                </div>
              }
            >
              {value?.limitKm ? (
                <InputNumberDouble
                  isOwner={isOwner}
                  typeOption={typeOption}
                  name={value.parentFeild}
                  disabled={!limitEdit}
                  disableSub={!isEdit}
                  onChangeForm={this.props.onChangeForm}
                  feild1={value.feild1}
                  feild2={value.feild2}
                />
              ) : (
                <InputNumber
                  className={
                    !isOwner && typeOption !== "create_new" ? "hidePrice" : ""
                  }
                  is_money
                  disabled={
                    !limitEdit || (typeOption !== "create_new" && !isOwner)
                  }
                  suffix={value.suffix}
                />
              )}
            </Form.Item>
          );
        })}
      </>
    );
  }
}
